var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDial3(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 28.592,
    height: 28.61,
    viewBox: "0 0 28.592 28.61",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    y1: 0.5,
    x2: 0.898,
    y2: 0.5,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#338fee"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#43c6fe"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Icon_feather-phone",
    x: 0,
    y: 0,
    width: 28.592,
    height: 28.61,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_116819",
    "data-name": "Group 116819",
    transform: "translate(24331.832 22639.84)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_267",
    "data-name": "Ellipse 267",
    transform: "translate(-24327.537 -22638.535)",
    fill: "#141623",
    stroke: "#42c3fd",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 10,
    r: 10,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 10,
    r: 9.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -24331.83, -22639.84)",
    filter: "url(#Icon_feather-phone)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon_feather-phone-2",
    "data-name": "Icon feather-phone",
    d: "M10.808,12.111c-.043,0-.087,0-.131-.006h-.009a10.11,10.11,0,0,1-4.385-1.559A9.985,9.985,0,0,1,3.234,7.5,10.108,10.108,0,0,1,1.675,3.09V3.082A1.452,1.452,0,0,1,3.118,1.5H4.58A1.452,1.452,0,0,1,6.017,2.748v0A5.738,5.738,0,0,0,6.33,4.007,1.455,1.455,0,0,1,6,5.537l0,0-.347.347A7.264,7.264,0,0,0,7.873,8.1l.347-.347,0,0a1.451,1.451,0,0,1,1.532-.327,5.735,5.735,0,0,0,1.253.312h0a1.451,1.451,0,0,1,1.249,1.467v1.445a1.452,1.452,0,0,1-1.452,1.457Zm-.04-.969.04,0a.484.484,0,0,0,.484-.486s0,0,0,0V9.2s0-.008,0-.012a.484.484,0,0,0-.414-.491,6.707,6.707,0,0,1-1.463-.365.484.484,0,0,0-.511.108l-.614.614a.484.484,0,0,1-.581.078A8.23,8.23,0,0,1,4.624,6.051.484.484,0,0,1,4.7,5.469l.613-.613a.485.485,0,0,0,.108-.51,6.71,6.71,0,0,1-.365-1.464.486.486,0,0,0-.479-.415H3.119a.484.484,0,0,0-.481.524,9.136,9.136,0,0,0,1.41,3.979l0,0A9.01,9.01,0,0,0,6.8,9.729l0,0A9.137,9.137,0,0,0,10.768,11.141Z",
    transform: "translate(7.33 4.5)",
    fill: "url(#linear-gradient)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDial3);
export default __webpack_public_path__ + "static/media/Dial3.ca5a223b68ec41496a264f8bb8b0ee8e.svg";
export { ForwardRef as ReactComponent };